import { SettlementStatusTypes } from "../../apis/Settlement/types";
import { Service } from "../enums";

const DATE_FORMAT = "YYYY/MM/DD";
const DATE_FORMAT_YMDHMS = "YYYY/MM/DD HH:mm:ss";
const catalogBrandKeys = {
  BRAND_LIST: "catalog_brand_list",
};
const catalogCategoryKeys = {
  CATEGORY_LIST: "catalog_category_list",
};
const productCategoryKeys = {
  CATEGORY_LIST: "product_category_list",
};
const productBrandKeys = {
  BRAND_LIST: "product_brnad_list",
};
const QUERY_KEY_FILTER = "filter";
const catalogGroupKeys = {
  GROUP_LIST: "catalog_group_list",
};
const placeHolder = {
  EMAIL: "이메일을 입력해주세요",
  ID: "아이디를 입력해주세요",
  PASS: "비밀번호를 입력해주세요",
  AUTH_NAME: "권한 명칭을 입력해주세요",
  AUTH_DESC: "권한 설명을 입력해주세요",
  NAME: "이름을 입력해주세요",
  TITLE: "제목을 입력해주세요",
  BODY: "내용을 입력해주세요",
  PHONE: "휴대폰번호를 입력해주세요",
  USER: "사용자를 입력해주세요",
  NUMBER: "숫자만 입력해주세요",
  REPASS: "비밀번호를 한 번 더 입력해주세요",
};
const holidays = [
  "신정",
  "설날연휴",
  "삼일절",
  "어린이날",
  "석가탄신일",
  "현충일",
  "광복절",
  "추석연휴",
  "개천절",
  "한글날",
  "성탄절",
];
const masterCodes = ["ZZZZZZZ", "ZZZZ"];
const TABLE_GENERATE = "등록하기";
const CANCEL_CONFIRM = `작성 내용이 저장되지 않습니다.`;
export const IMAGE_URL_SERVER = "http://tirepick-static.slogup.com/";
export const SERVICE_KEY = Service.BOS_WEB;
const TEXT_BOS = "타이어픽 BOS";
const TEXT_REPAIRSHOP = "장착점 파트너즈";
const TEXT_CUSTOMER_APP = "소비자앱";
const TEXT_BAR = "ㅣ";
const ALERT_MESSAGE = {
  PHONE_SEND: "문자가 전송되었습니다.인증 코드를 확인해주세요",
  PHONE_SEND_FAILURE: "문자 전송에 실패하였습니다. 다시 시도 해주세요",
  NO_PHONE_AUTH: "휴대폰 번호 인증이 필요합니다",
  WRONG_AUTH: "인증번호가 일치하지 않습니다.확인후 다시 진행해주세요",
  NO_DUPLIACTE_CHECK: "아이디 중복확인이 필요합니다",
  INVALID_REPASS: "비밀번호 확인이 일치하지 않습니다",
  NEED_NAME: "성함을 입력해주세요",
  WRONG_PHONE: "올바른 휴대폰 번호를 입력해주세요",
  WRONG_EMAIL: "올바른 이메일 주소를 입력해주세요",
  NEED_NUMBER: "올바른 번호를 입력해주세요",
  EXCEED_AUTH_TIME: "인증시간이 초과되었습니다",
  EXCEED_FILE_SIZE: "파일 용량이 초과되었습니다.최대 5MB까지 가능",
  INVALID_FILE_FORMAT: "파일 형식을 다시 확인해주세요.JPG,PNG,GIF 형식만 가능",
  NULL_REQUIRED: "필수 값입니다.",
  NO_SAME_TIME: "시작시간은 종료시간과 같을 수 없습니다",
  NOT_VERIFIED_EMAIL: "등록된 이메일과 휴대폰번호가 일치하지 않습니다",
  DONT_HAVE_DAY: "요일을 선택해주세요.",
  FAILED_REQUEST: "요청을 보내는데 실패하였습니다.",
  NO_DUPLICATED_CLOSE_DAY: "영업 중단 날짜는 서로 겹치게 설정할 수 없습니다.",
  IS_BEFORE_TIME: "시작시간이 종료시간과 같거나 종료시간보다 느릴 수 없습니다.",
};
const folders = {
  TERM_HISTORY: "term-history/",
};

const defaultNull = [-1, undefined, "", null, {}];

export const translateSettlementStatusTypes: {
  [key in SettlementStatusTypes]: string;
} = {
  SERVICE_COMPLETED: "장착완료",
  SETTLEMENT_REQUESTED: "정산요청",
  SETTLEMENT_CONFIRMED: "정산확인",
  PAY_COMPLETED: "지급완료",
};

const sharedConstants = {
  date: {
    format: DATE_FORMAT,
    formatYMDHMS: DATE_FORMAT_YMDHMS,
    alertMessage: ALERT_MESSAGE,
  },
  message: {
    CANCEL_CONFIRM,
    ALERT_MESSAGE,
  },
  masterCodes,
  folders,
  text: { TEXT_BOS, TEXT_REPAIRSHOP, TEXT_CUSTOMER_APP, TEXT_BAR },
  defaultNull,
  placeHolder,
  useQueryKeys: {
    catalogBrandKeys,
    catalogCategoryKeys,
    catalogGroupKeys,
    productBrandKeys,
    productCategoryKeys,
  },
  QUERY_KEY_FILTER,
  TABLE_GENERATE,
  arrays: {
    holidays,
  },
};

export default sharedConstants;
